import { useEffect } from 'react';
import { getCleanedUrlParams, showError } from '@utils';
import { QUERY_KEYS } from 'constants/queryKeys';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { emailTemplatesServices } from 'services/emailTemplates';
import { useAssignees } from 'hooks/common';
import {
  getEmailTemplatesRequestPayload,
  handleEmailTemplatesData,
  normalizeAgents,
} from './utils';

export const EMAIL_TEMPLATES_PAGE_SIZE = 100;

export const useEmailTemplatesOperations = () => {
  const router = useRouter();
  const { assignees, isLoading: isAssigneesLoading } = useAssignees();
  const page = router.query?.page || 1;
  const pageSize = router.query?.pageSize || EMAIL_TEMPLATES_PAGE_SIZE;
  const query = router.query?.query;

  const params = {
    page,
    pageSize: parseInt(pageSize, 10) || EMAIL_TEMPLATES_PAGE_SIZE,
  };

  const urlParams = {
    page,
    pageSize: parseInt(pageSize, 10) || EMAIL_TEMPLATES_PAGE_SIZE,
    query,
  };

  const cleanParams = getCleanedUrlParams(params);
  const cleanUrlParams = getCleanedUrlParams(urlParams);

  const emailTemplatesResponse = useQuery(
    [QUERY_KEYS.GET_EMAIL_TEMPLATES, cleanParams, cleanUrlParams],
    () => {
      const payload = getEmailTemplatesRequestPayload(cleanParams);

      return emailTemplatesServices.getEmailTemplates({
        params: cleanUrlParams,
        payload,
      });
    }
  );

  const enumsResponse = useQuery(
    [QUERY_KEYS.GET_EMAIL_TEMPLATES_ENUMS_KEY],
    () => emailTemplatesServices.getEmailTemplatesEnums()
  );

  const agents = normalizeAgents(assignees);
  const emailTemplates = handleEmailTemplatesData(
    emailTemplatesResponse?.data?.data,
    agents
  );

  useEffect(() => {
    if (emailTemplatesResponse?.error) {
      showError(emailTemplatesResponse?.error);
    }
  }, [emailTemplatesResponse?.error]);

  return {
    page,
    total: emailTemplatesResponse?.data?.meta?.total,
    error: emailTemplatesResponse?.error,
    isSuccess: emailTemplatesResponse?.isSuccess,
    loading: emailTemplatesResponse?.isLoading || isAssigneesLoading,
    pageSize: parseInt(pageSize, 10) || EMAIL_TEMPLATES_PAGE_SIZE,
    emailTemplates,
    enums: enumsResponse?.data?.data || {},
    getEmailTemplates: emailTemplatesResponse.refetch,
  };
};
